<template>
  <ButtonSnsSmall class="btn-sns--x" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-x-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--x {
  @include bg-settings(
    '../../../../../../images/buttons/x-with-background.svg',
    $x,
    100%,
    100%
  );
}
</style>
